<template>
  <aside
    :class="[
      'main-sidebar',
      'col-12',
      'col-md-3',
      widthLarge,
      'px-0',
      sidebarVisible ? 'open' : '',
    ]"
  >
    <div class="main-navbar">
      <nav
        class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0"
      >
        <router-link
          class="navbar-brand w-100 mr-0"
          to="/"
          style="line-height: 25px"
        >
          <div class="d-table m-auto">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 80px"
              src="@/assets/images/omja.png"
              alt="OMJA Software"
            />
            <span v-if="!displayColapse" class="d-none d-md-inline ml-1">
              {{ $t("menu.top.title") }}
            </span>
          </div>
        </router-link>
        <a
          class="toggle-sidebar d-sm-inline d-md-none d-lg-none"
          @click="handleToggleSidebar()"
        >
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div>

    <!-- <form
      action="#"
      class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none"
    >
      <div class="input-group input-group-seamless ml-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <i class="fas fa-search"></i>
          </div>
        </div>
        <input
          class="navbar-search form-control"
          type="text"
          placeholder="Search for something..."
          aria-label="Search"
        />
      </div>
    </form> -->
    <div class="nav-wrapper" v-if="items">
      <div v-for="(nav, navIdx) in items" :key="navIdx">
        <template v-if="checkPermissions(nav.permissions)">
          <h6 v-if="nav.title" class="main-sidebar__nav-title">
            {{ $t(nav.title) }}
          </h6>
          <d-nav
            v-if="typeof nav.items !== 'undefined' && nav.items.length"
            :class="['nav--no-borders flex-column', textAlign]"
          >
            <template v-for="(item, navItemIdx) in nav.items">
              <li
                v-if="checkPermissions(item.permissions, item)"
                :key="navItemIdx"
                class="nav-item dropdown"
                @click="expand()"
              >
                <d-link
                  :class="[
                    'nav-link',
                    item.items && item.items.length ? 'dropdown-toggle' : '',
                  ]"
                  :to="item.to"
                  v-d-toggle="`snc-${navIdx}-${navItemIdx}`"
                >
                  <div
                    class="item-icon-wrapper"
                    v-if="item.htmlBefore"
                    v-html="item.htmlBefore"
                  />
                  <span
                    v-if="
                      $t(item.title) == 'Utilisateurs' ||
                      $t(item.title) == 'Demandes'
                    "
                  >
                    {{ $t(item.title) }}
                  </span>
                  <span
                    v-else-if="$t(item.title) == 'Déconnexion'"
                    @click="logout"
                  >
                    {{ $t(item.title) }}
                  </span>
                  <span v-else @click="handleToggleSidebar()">
                    {{ $t(item.title) }}</span
                  >
                  <div
                    v-if="item.htmlAfter"
                    class="item-icon-wrapper"
                    v-html="
                      $t(item.title) == 'Notifications' ? notificationCount : ''
                    "
                  />
                </d-link>
                <d-collapse
                  v-if="item.items && item.items.length"
                  :id="`snc-${navIdx}-${navItemIdx}`"
                  class="dropdown-menu dropdown-menu-small"
                  accordion="sidebar-items-accordion"
                >
                  <div @click="handleToggleSidebar()">
                    <template v-for="(subItem, subItemIdx) in item.items">
                      <d-dropdown-item
                        v-if="checkPermissions(subItem.permissions)"
                        :key="subItemIdx"
                        :href="subItem.href"
                        :to="subItem.to"
                      >
                        {{ $t(subItem.title) }}
                      </d-dropdown-item>
                    </template>
                  </div>
                </d-collapse>
              </li>
            </template>
          </d-nav>
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
import PermissionsUtil from "../../../utils/PermissionsUtil";

export default {
  name: "main-sidebar",
  props: {
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sidebarVisible: false,
      displayColapse: false,
      widthLarge: "col-lg-2",
      textAlign: "",
      icon: '<i class="material-icons">keyboard_arrow_left</i>',
      text: "Collapse",
    };
  },
  mounted() {
    this.$root.$on("MainSidebar", () => {
      this.collapse();
    });
  },

  created() {
    this.$eventHub.$on("toggle-sidebar", this.handleToggleSidebar);
  },
  beforeDestroy() {
    this.$eventHub.$off("toggle-sidebar");
  },

  computed: {
    isAnimator() {
      let flag = true;
      this.$store.state.user.informations.permissions.forEach((p) => {
        if (p.groupReference == "_animateur") {
          flag = false;
        }
      });
      return flag;
    },

    user() {
      return this.$store.state.user.informations;
    },

    notificationCount() {
      const notifications = this.$store.state.user.notifications.filter(
        (n) => n.read == false
      );
      return notifications.length
        ? `<div class="notification-count"> ${notifications.length} </div>`
        : "";
    },
  },

  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },

    collapseMainSidebar() {
      if (!this.displayColapse) {
        this.collapse();
      } else {
        this.expand();
      }
    },

    collapse() {
      this.displayColapse = true;
      this.widthLarge = "col-lg-1";
      this.textAlign = "text-center";
      this.icon = '<i class="material-icons">keyboard_arrow_right</i>';
      this.text = "Expands";
      this.$emit("mainContentWidth", {
        offsetCol: "offset-lg-1",
        contentWidth: 11,
      });
      this.$store.dispatch("setCollapseSideBar", true);
    },

    expand() {
      this.displayColapse = false;
      this.widthLarge = "col-lg-2";
      this.textAlign = "";
      this.icon = '<i class="material-icons">keyboard_arrow_left</i>';
      this.text = "Collapse";
      this.$emit("mainContentWidth", {
        offsetCol: "offset-lg-2",
        contentWidth: 10,
      });
      this.$store.dispatch("setCollapseSideBar", false);
    },

    logout() {
      this.handleToggleSidebar();
      this.$socket.emit("close_user", {
        reference: this.$store.state.user.informations.reference,
      });
      this.$services.user.logout().then(() => {
        this.$router.push("/login");
      });
    },

    checkPermissions(permissions, title) {
      if (!permissions) {
        return true;
      }
      return PermissionsUtil.checkPermissions(
        this.$store.state.user.informations.permissions,
        permissions,
        title
      );
    },
  },
};
</script>

<style lang="scss">
.main-sidebar {
  .item-icon-wrapper {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }
}
.notification-count {
  background-color: orangered;
  color: white;
  margin-left: 10px;
  width: 20px;
  height: 20px;
  text-align: center;
  font-weight: bold;
  border-radius: 50%;
}
</style>
